import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface PromoModalData {
  content:[{ promo_title?: string;
  promo_text?: string;}]
  buttons?: [PromoModalAction];
}
export interface PromoModalAction{
  text: string
  value: string;
}
@Component({
  selector: 'promo-modal',
  templateUrl: './promo-modal.component.html',
  styleUrls: ['./promo-modal.component.scss']
})
export class PromoModalComponent implements OnInit{

  constructor(
    public dialogRef: MatDialogRef<PromoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
    console.log(this.data)
  }
  
  onNoClick(): void {
    this.dialogRef.close();
  }
  

}
